import { pick } from "lodash";
/** Return only the values from `obj` corresponding to the given `keys. */
export function pickValues(obj, keys) {
    return Object.values(pick(obj, keys));
}
//# sourceMappingURL=pickValues.js.map